import { render, staticRenderFns } from "./marketTypeManagement.vue?vue&type=template&id=0e8107ca"
import script from "./marketTypeManagement.vue?vue&type=script&lang=js"
export * from "./marketTypeManagement.vue?vue&type=script&lang=js"
import style0 from "./marketTypeManagement.vue?vue&type=style&index=0&id=0e8107ca&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports